import { Avatar } from '@heroui/react';

interface UserAvatarProps {
  name: string;
  photoUrl?: string | null;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

function getInitials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0]!.slice(0, 2).toUpperCase();
  return `${parts[0]![0] ?? ''}${parts[1]![0] ?? ''}`.toUpperCase();
}

export function UserAvatar({ name, photoUrl, size = 'sm', className }: UserAvatarProps) {
  const initials = getInitials(name);

  return (
    <Avatar size={size} className={className}>
      {photoUrl ? <Avatar.Image src={photoUrl} alt={name} /> : null}
      <Avatar.Fallback delayMs={photoUrl ? 600 : 0}>{initials}</Avatar.Fallback>
    </Avatar>
  );
}
